import { User } from '@features/users/types';
import { ColumnFilter, ColumnFilters } from '@shared/types';
import { Dispatch, SetStateAction, useCallback, useMemo } from 'react';

interface UserFilterProps {
    columnFilters: ColumnFilters;
    setColumnFilters: Dispatch<SetStateAction<ColumnFilters>>;
    accessorKey?: string;
}

export const useUserFilter = ({ columnFilters, setColumnFilters, accessorKey }: UserFilterProps) => {
    const filterKey = accessorKey ?? 'created_by_user';
    const userId = useMemo(() => {
        const userFilter = columnFilters?.find((filter: ColumnFilter) => filter.id === filterKey);
        return userFilter ? Number(userFilter.value) : null;
    }, [columnFilters, filterKey]);

    const handleChangeUserFilter = useCallback(
        (newValue: User['pk']) => {
            if (!setColumnFilters) return;
            setColumnFilters((filters: ColumnFilters) => [
                ...filters.filter((filter) => filter.id !== filterKey),
                { id: filterKey, value: String(newValue) },
            ]);
        },
        [setColumnFilters, filterKey],
    );

    const handleClearUserFilter = useCallback(() => {
        if (!setColumnFilters) return;
        setColumnFilters((filters: ColumnFilters) => filters.filter((filter) => filter.id !== filterKey));
    }, [setColumnFilters, filterKey]);

    return { userId, handleChangeUserFilter, handleClearUserFilter };
};
